import React from "react";
import HeadingSubHeading from "../../../../components/ViewHeading/HeadingSubHeading";
import { WallConfig } from "../../../../entity/Organisations/Employees/Settings/WallConfig";
import { Card, Space } from "antd";
import RenderForm from "../../../../components/Forms/Form";

const Wall = () => {


    return (
        <Card title={
            <HeadingSubHeading titleProps={{ level: 5 }}
                title={'Wall Settings'}
                subTitle="Wall is the social field for employees. These are the settings for wall." />
        }>
            <RenderForm config={WallConfig} />
        </Card>
    );
}

export default Wall;